import { useEffect, useState } from "react";

import Intercom from "@intercom/messenger-js-sdk";

import backendClient from "src/api";
import useUser from "./hooks/useUser";

export const HELP_CENTER_URL =
  "https://intercom.help/lumonic-590ad7677eae/en/";

const IntercomLauncher = () => {
  const { user, memberships } = useUser();

  const [intercomToken, setIntercomToken] = useState<string | null>(null);

  useEffect(() => {
    if (!user) return;

    backendClient.intercom
      .getIntercomToken()
      .then((response) => {
        if (response.token) {
          setIntercomToken(response.token);
        }
      })
      .catch(() => {
        // Identity verification unavailable in this environment
      });
  }, [user]);

  useEffect(() => {
    if (!user || !intercomToken) return;

    const extractNames = (
      key: "cluster" | "entity",
      nameKey: "name" | "clusterName"
    ) =>
      memberships
        ?.filter((membership) => membership[key])
        .map((membership) => membership[key][nameKey])
        .join(", ");

    const clusters =
      extractNames("cluster", "name") || extractNames("entity", "clusterName");

    const entityMemberships = extractNames("entity", "name");

    Intercom({
      app_id: import.meta.env.VITE_INTERCOM_APP_ID,
      user_id: user?.id,
      name: user?.fullName ?? "",
      email: user?.email,
      intercom_user_jwt: intercomToken,
      custom_launcher_selector: "#custom-intercom-launcher",
      hide_default_launcher: true,
      cluster_memberships: clusters,
      entity_memberships: entityMemberships,
    });
  }, [user, intercomToken]);

  return <div id="custom-intercom-launcher" className="hidden" />;
};

export default IntercomLauncher;
